import { createBrowserRouter } from "react-router-dom";
import AppLayout from "../components/layout/AppLayout";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import HomePage from "../pages/HomePage";
import SignInPage from "../pages/auth/SignInPage";
import OperationProjectListPage from "../pages/operation/OperationProjectListPage";
import OperationProgramListPage from "../pages/operation/OperationProgramListPage";
import WorkerListPage from "../pages/workers/WorkerListPage";
import WorkerDetailPage from "../pages/workers/WorkerDetailPage";
import WorkerGoalListPage from "../pages/workers/WorkerGoalListPage";
import WorkerAchievementListPage from "../pages/workers/WorkerAchievementListPage";
import WorkflowListPage from "../pages/workers/WorkflowListPage";
import WorkflowDetailPage from "../pages/workers/WorkflowDetailPage";
import WorkDetailPage from "../pages/workers/WorkDetailPage";
import WorkerProjectGoalAchievementListPage from "../pages/workers/WorkerProjectGoalAchievementListPage";
import WorkerProgramGoalAchievementListPage from "../pages/workers/WorkerProgramGoalAchievementListPage";
import WorkHistoryPage from "../pages/workers/WorkHistoryPage";
import IdeaListPage from "../pages/ideas/IdeaListPage";
import AwarenessListPage from "../pages/awareness/AwarenessListPage";

// ── 経営理念 ──
import CompanyValuesPage from "../pages/design/CompanyValuesPage";

// ── Design pages ──
import BusinessDomainDetailPage from "../pages/design/BusinessDomainDetailPage";
// Strategy Map
import SmFinancialGoalListPage from "../pages/design/SmFinancialGoalListPage";
import SmFinancialGoalDetailPage from "../pages/design/SmFinancialGoalDetailPage";
import SmCustomerValueListPage from "../pages/design/SmCustomerValueListPage";
import SmCustomerValueDetailPage from "../pages/design/SmCustomerValueDetailPage";
import SmStrategicGoalListPage from "../pages/design/SmStrategicGoalListPage";
import SmStrategicGoalDetailPage from "../pages/design/SmStrategicGoalDetailPage";
import SmStrategicIssueListPage from "../pages/design/SmStrategicIssueListPage";
import SmStrategicIssueDetailPage from "../pages/design/SmStrategicIssueDetailPage";
import SmHumanCapitalGoalListPage from "../pages/design/SmHumanCapitalGoalListPage";
import SmHumanCapitalGoalDetailPage from "../pages/design/SmHumanCapitalGoalDetailPage";
import SmInfoCapitalGoalAppListPage from "../pages/design/SmInfoCapitalGoalAppListPage";
import SmInfoCapitalGoalAppDetailPage from "../pages/design/SmInfoCapitalGoalAppDetailPage";
import SmInfoCapitalGoalDataListPage from "../pages/design/SmInfoCapitalGoalDataListPage";
import SmInfoCapitalGoalDataDetailPage from "../pages/design/SmInfoCapitalGoalDataDetailPage";
import SmInfoCapitalGoalItListPage from "../pages/design/SmInfoCapitalGoalItListPage";
import SmInfoCapitalGoalItDetailPage from "../pages/design/SmInfoCapitalGoalItDetailPage";
import SmOrgCapitalGoalListPage from "../pages/design/SmOrgCapitalGoalListPage";
import SmOrgCapitalGoalDetailPage from "../pages/design/SmOrgCapitalGoalDetailPage";
// Asset types
import CustomerTypeListPage from "../pages/design/CustomerTypeListPage";
import CustomerTypeDetailPage from "../pages/design/CustomerTypeDetailPage";
import ProductTypeListPage from "../pages/design/ProductTypeListPage";
import ProductTypeDetailPage from "../pages/design/ProductTypeDetailPage";
import MemberTypeListPage from "../pages/design/MemberTypeListPage";
import MemberTypeDetailPage from "../pages/design/MemberTypeDetailPage";
import PartnerTypeListPage from "../pages/design/PartnerTypeListPage";
import PartnerTypeDetailPage from "../pages/design/PartnerTypeDetailPage";
import DataDomainListPage from "../pages/design/DataDomainListPage";
import DataDomainDetailPage from "../pages/design/DataDomainDetailPage";
import DataTypeListPage from "../pages/design/DataTypeListPage";
import DataTypeDetailPage from "../pages/design/DataTypeDetailPage";
import DataItemDetailPage from "../pages/design/DataItemDetailPage";
import ApplicationTypeListPage from "../pages/design/ApplicationTypeListPage";
import ApplicationTypeDetailPage from "../pages/design/ApplicationTypeDetailPage";
import ItTypeListPage from "../pages/design/ItTypeListPage";
import ItTypeDetailPage from "../pages/design/ItTypeDetailPage";
import FinancialAssetTypeListPage from "../pages/design/FinancialAssetTypeListPage";
import FinancialAssetTypeDetailPage from "../pages/design/FinancialAssetTypeDetailPage";
import PlaceTypeListPage from "../pages/design/PlaceTypeListPage";
import PlaceTypeDetailPage from "../pages/design/PlaceTypeDetailPage";
// Functions / Activities
import JobListPage from "../pages/design/JobListPage";
import JobDetailPage from "../pages/design/JobDetailPage";
import TaskListPage from "../pages/design/TaskListPage";
import TaskDetailPage from "../pages/design/TaskDetailPage";
import BusinessProcessListPage from "../pages/design/BusinessProcessListPage";
import BusinessProcessDetailPage from "../pages/design/BusinessProcessDetailPage";
import ValueChainListPage from "../pages/design/ValueChainListPage";
import ValueChainDetailPage from "../pages/design/ValueChainDetailPage";

// ── Strategy pages ──
import BusinessUnitDetailPage from "../pages/strategy/BusinessUnitDetailPage";
// BSC
import BscGoalListPage from "../pages/strategy/bsc/BscGoalListPage";
import BscGoalDetailPage from "../pages/strategy/bsc/BscGoalDetailPage";
import BscAchievementListPage from "../pages/strategy/bsc/BscAchievementListPage";
// Asset categories
import CustomerCategoryListPage from "../pages/strategy/CustomerCategoryListPage";
import CustomerCategoryDetailPage from "../pages/strategy/CustomerCategoryDetailPage";
import ProductCategoryListPage from "../pages/strategy/ProductCategoryListPage";
import ProductCategoryDetailPage from "../pages/strategy/ProductCategoryDetailPage";
import MemberCategoryListPage from "../pages/strategy/MemberCategoryListPage";
import MemberCategoryDetailPage from "../pages/strategy/MemberCategoryDetailPage";
import PartnerCategoryListPage from "../pages/strategy/PartnerCategoryListPage";
import PartnerCategoryDetailPage from "../pages/strategy/PartnerCategoryDetailPage";
import DataCategoryListPage from "../pages/strategy/DataCategoryListPage";
import DataCategoryDetailPage from "../pages/strategy/DataCategoryDetailPage";
import ApplicationCategoryListPage from "../pages/strategy/ApplicationCategoryListPage";
import ApplicationCategoryDetailPage from "../pages/strategy/ApplicationCategoryDetailPage";
import ItCategoryListPage from "../pages/strategy/ItCategoryListPage";
import ItCategoryDetailPage from "../pages/strategy/ItCategoryDetailPage";
import FinancialAssetCategoryListPage from "../pages/strategy/FinancialAssetCategoryListPage";
import FinancialAssetCategoryDetailPage from "../pages/strategy/FinancialAssetCategoryDetailPage";
import PlaceCategoryListPage from "../pages/strategy/PlaceCategoryListPage";
import PlaceCategoryDetailPage from "../pages/strategy/PlaceCategoryDetailPage";
// Functions / Activities / Management
import DepartmentListPage from "../pages/strategy/DepartmentListPage";
import DepartmentDetailPage from "../pages/strategy/DepartmentDetailPage";
import ActionPlanListPage from "../pages/strategy/ActionPlanListPage";
import ActionPlanDetailPage from "../pages/strategy/ActionPlanDetailPage";
import ProjectListPage from "../pages/strategy/ProjectListPage";
import ProjectDetailPage from "../pages/strategy/ProjectDetailPage";
import ProjectGoalListPage from "../pages/strategy/ProjectGoalListPage";
import ProjectGoalDetailPage from "../pages/strategy/ProjectGoalDetailPage";
import ProgramListPage from "../pages/strategy/ProgramListPage";
import ProgramDetailPage from "../pages/strategy/ProgramDetailPage";
import ProgramGoalListPage from "../pages/strategy/ProgramGoalListPage";

const router = createBrowserRouter([
  { path: "/signin", element: <SignInPage /> },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <HomePage /> },
      {
        path: "operation",
        children: [
          { path: "projects", element: <OperationProjectListPage /> },
          { path: "programs", element: <OperationProgramListPage /> },
        ],
      },
      // ── 経営理念 ──
      { path: "company-values", element: <CompanyValuesPage /> },
      // ── 設計 ──
      {
        path: "design",
        children: [
          { path: ":businessDomainId", element: <BusinessDomainDetailPage /> },
          // Strategy Map
          { path: ":businessDomainId/strategy-map/financial-goals", element: <SmFinancialGoalListPage /> },
          { path: ":businessDomainId/strategy-map/financial-goals/:successFactorId", element: <SmFinancialGoalDetailPage /> },
          { path: ":businessDomainId/strategy-map/customer-values", element: <SmCustomerValueListPage /> },
          { path: ":businessDomainId/strategy-map/customer-values/:successFactorId", element: <SmCustomerValueDetailPage /> },
          { path: ":businessDomainId/strategy-map/strategic-goals", element: <SmStrategicGoalListPage /> },
          { path: ":businessDomainId/strategy-map/strategic-goals/:successFactorId", element: <SmStrategicGoalDetailPage /> },
          { path: ":businessDomainId/strategy-map/strategic-issues", element: <SmStrategicIssueListPage /> },
          { path: ":businessDomainId/strategy-map/strategic-issues/:successFactorId", element: <SmStrategicIssueDetailPage /> },
          { path: ":businessDomainId/strategy-map/human-capital-goals", element: <SmHumanCapitalGoalListPage /> },
          { path: ":businessDomainId/strategy-map/human-capital-goals/:successFactorId", element: <SmHumanCapitalGoalDetailPage /> },
          { path: ":businessDomainId/strategy-map/info-capital-goals-app", element: <SmInfoCapitalGoalAppListPage /> },
          { path: ":businessDomainId/strategy-map/info-capital-goals-app/:successFactorId", element: <SmInfoCapitalGoalAppDetailPage /> },
          { path: ":businessDomainId/strategy-map/info-capital-goals-data", element: <SmInfoCapitalGoalDataListPage /> },
          { path: ":businessDomainId/strategy-map/info-capital-goals-data/:successFactorId", element: <SmInfoCapitalGoalDataDetailPage /> },
          { path: ":businessDomainId/strategy-map/info-capital-goals-it", element: <SmInfoCapitalGoalItListPage /> },
          { path: ":businessDomainId/strategy-map/info-capital-goals-it/:successFactorId", element: <SmInfoCapitalGoalItDetailPage /> },
          { path: ":businessDomainId/strategy-map/org-capital-goals", element: <SmOrgCapitalGoalListPage /> },
          { path: ":businessDomainId/strategy-map/org-capital-goals/:successFactorId", element: <SmOrgCapitalGoalDetailPage /> },
          // Asset types
          { path: ":businessDomainId/customer-types", element: <CustomerTypeListPage /> },
          { path: ":businessDomainId/customer-types/:customerTypeId", element: <CustomerTypeDetailPage /> },
          { path: ":businessDomainId/product-types", element: <ProductTypeListPage /> },
          { path: ":businessDomainId/product-types/:productTypeId", element: <ProductTypeDetailPage /> },
          { path: ":businessDomainId/member-types", element: <MemberTypeListPage /> },
          { path: ":businessDomainId/member-types/:memberTypeId", element: <MemberTypeDetailPage /> },
          { path: ":businessDomainId/partner-types", element: <PartnerTypeListPage /> },
          { path: ":businessDomainId/partner-types/:partnerTypeId", element: <PartnerTypeDetailPage /> },
          { path: ":businessDomainId/data-domains", element: <DataDomainListPage /> },
          { path: ":businessDomainId/data-domains/:dataDomainId", element: <DataDomainDetailPage /> },
          { path: ":businessDomainId/data-types", element: <DataTypeListPage /> },
          { path: ":businessDomainId/data-types/:dataTypeId", element: <DataTypeDetailPage /> },
          { path: ":businessDomainId/data-types/:dataTypeId/data-items/:dataItemId", element: <DataItemDetailPage /> },
          { path: ":businessDomainId/application-types", element: <ApplicationTypeListPage /> },
          { path: ":businessDomainId/application-types/:applicationTypeId", element: <ApplicationTypeDetailPage /> },
          { path: ":businessDomainId/it-types", element: <ItTypeListPage /> },
          { path: ":businessDomainId/it-types/:itTypeId", element: <ItTypeDetailPage /> },
          { path: ":businessDomainId/financial-asset-types", element: <FinancialAssetTypeListPage /> },
          { path: ":businessDomainId/financial-asset-types/:financialAssetTypeId", element: <FinancialAssetTypeDetailPage /> },
          { path: ":businessDomainId/place-types", element: <PlaceTypeListPage /> },
          { path: ":businessDomainId/place-types/:placeTypeId", element: <PlaceTypeDetailPage /> },
          // Functions
          { path: ":businessDomainId/jobs", element: <JobListPage /> },
          { path: ":businessDomainId/jobs/:jobId", element: <JobDetailPage /> },
          { path: ":businessDomainId/jobs/:jobId/tasks", element: <TaskListPage /> },
          { path: ":businessDomainId/jobs/:jobId/tasks/:taskId", element: <TaskDetailPage /> },
          // Activities
          { path: ":businessDomainId/business-processes", element: <BusinessProcessListPage /> },
          { path: ":businessDomainId/business-processes/:businessProcessId", element: <BusinessProcessDetailPage /> },
          { path: ":businessDomainId/value-chains", element: <ValueChainListPage /> },
          { path: ":businessDomainId/value-chains/:valueChainId", element: <ValueChainDetailPage /> },
        ],
      },
      // ── 戦略 ──
      {
        path: "strategy",
        children: [
          // Business Unit detail
          { path: ":businessDomainId/business-units/:businessUnitId", element: <BusinessUnitDetailPage /> },
          // BSC
          { path: ":businessDomainId/business-units/:businessUnitId/bsc/:category", element: <BscGoalListPage /> },
          { path: ":businessDomainId/business-units/:businessUnitId/bsc/:category/:goalIdx", element: <BscGoalDetailPage /> },
          { path: ":businessDomainId/business-units/:businessUnitId/bsc/:category/:goalIdx/achievements", element: <BscAchievementListPage /> },
          // Asset categories (usesUnit)
          { path: ":businessDomainId/business-units/:businessUnitId/customer-categories", element: <CustomerCategoryListPage /> },
          { path: ":businessDomainId/business-units/:businessUnitId/customer-categories/:categoryId", element: <CustomerCategoryDetailPage /> },
          { path: ":businessDomainId/business-units/:businessUnitId/product-categories", element: <ProductCategoryListPage /> },
          { path: ":businessDomainId/business-units/:businessUnitId/product-categories/:categoryId", element: <ProductCategoryDetailPage /> },
          { path: ":businessDomainId/business-units/:businessUnitId/data-categories", element: <DataCategoryListPage /> },
          { path: ":businessDomainId/business-units/:businessUnitId/data-categories/:categoryId", element: <DataCategoryDetailPage /> },
          // Asset categories (no usesUnit - companyId based)
          { path: ":businessDomainId/member-categories", element: <MemberCategoryListPage /> },
          { path: ":businessDomainId/member-categories/:categoryId", element: <MemberCategoryDetailPage /> },
          { path: ":businessDomainId/partner-categories", element: <PartnerCategoryListPage /> },
          { path: ":businessDomainId/partner-categories/:categoryId", element: <PartnerCategoryDetailPage /> },
          { path: ":businessDomainId/application-categories", element: <ApplicationCategoryListPage /> },
          { path: ":businessDomainId/application-categories/:categoryId", element: <ApplicationCategoryDetailPage /> },
          { path: ":businessDomainId/it-categories", element: <ItCategoryListPage /> },
          { path: ":businessDomainId/it-categories/:categoryId", element: <ItCategoryDetailPage /> },
          { path: ":businessDomainId/financial-asset-categories", element: <FinancialAssetCategoryListPage /> },
          { path: ":businessDomainId/financial-asset-categories/:categoryId", element: <FinancialAssetCategoryDetailPage /> },
          { path: ":businessDomainId/place-categories", element: <PlaceCategoryListPage /> },
          { path: ":businessDomainId/place-categories/:categoryId", element: <PlaceCategoryDetailPage /> },
          // Functions (usesUnit)
          { path: ":businessDomainId/business-units/:businessUnitId/departments", element: <DepartmentListPage /> },
          { path: ":businessDomainId/business-units/:businessUnitId/departments/:departmentId", element: <DepartmentDetailPage /> },
          // Activities (usesUnit)
          { path: ":businessDomainId/business-units/:businessUnitId/action-plans", element: <ActionPlanListPage /> },
          { path: ":businessDomainId/business-units/:businessUnitId/action-plans/:actionPlanId", element: <ActionPlanDetailPage /> },
          // Management (usesUnit)
          { path: ":businessDomainId/business-units/:businessUnitId/projects", element: <ProjectListPage /> },
          { path: ":businessDomainId/business-units/:businessUnitId/projects/:projectId", element: <ProjectDetailPage /> },
          { path: ":businessDomainId/business-units/:businessUnitId/projects/:projectId/goals", element: <ProjectGoalListPage /> },
          { path: ":businessDomainId/business-units/:businessUnitId/projects/:projectId/goals/:goalId", element: <ProjectGoalDetailPage /> },
          { path: ":businessDomainId/business-units/:businessUnitId/programs", element: <ProgramListPage /> },
          { path: ":businessDomainId/business-units/:businessUnitId/programs/:programId", element: <ProgramDetailPage /> },
          { path: ":businessDomainId/business-units/:businessUnitId/programs/:programId/goals", element: <ProgramGoalListPage /> },
        ],
      },
      // ── Workers, Ideas, Awareness ──
      {
        path: "workers",
        children: [
          { index: true, element: <WorkerListPage /> },
          { path: ":workerId", element: <WorkerDetailPage /> },
          { path: ":workerId/goals", element: <WorkerGoalListPage /> },
          { path: ":workerId/achievements", element: <WorkerAchievementListPage /> },
          { path: ":workerId/project-goal-achievements", element: <WorkerProjectGoalAchievementListPage /> },
          { path: ":workerId/program-goal-achievements", element: <WorkerProgramGoalAchievementListPage /> },
          { path: ":workerId/history", element: <WorkHistoryPage /> },
          {
            path: ":workerId/workflows",
            children: [
              { index: true, element: <WorkflowListPage /> },
              {
                path: ":workflowId",
                children: [
                  { index: true, element: <WorkflowDetailPage /> },
                  {
                    path: "works/:workId",
                    element: <WorkDetailPage />,
                  },
                ],
              },
            ],
          },
        ],
      },
      { path: "ideas", element: <IdeaListPage /> },
      { path: "awareness", element: <AwarenessListPage /> },
    ],
  },
]);

export default router;
